var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.208984 8.45762C0.208984 4.24108 3.73254 0.833008 7.99464 0.833008C12.2688 0.833008 15.7923 4.24108 15.7923 8.45762C15.7923 10.5824 15.0196 12.555 13.7477 14.227C12.3446 16.0712 10.6151 17.6781 8.66848 18.9394C8.22295 19.2309 7.82087 19.2529 7.3319 18.9394C5.37416 17.6781 3.64473 16.0712 2.25361 14.227C0.980803 12.555 0.208984 10.5824 0.208984 8.45762ZM5.42861 8.6955C5.42861 10.108 6.58126 11.219 7.99456 11.219C9.40879 11.219 10.5725 10.108 10.5725 8.6955C10.5725 7.29396 9.40879 6.12891 7.99456 6.12891C6.58126 6.12891 5.42861 7.29396 5.42861 8.6955Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6212b0cad0375a3ab942507db37daaf8.svg";
export { ForwardRef as ReactComponent };